export { ablyAdapter } from './realtime-ably-adapter.ts'
